import Styled from './styled'
// import { ResponsiveBar } from '@nivo/bar'
// import { ResponsiveLine } from '@nivo/line'
import _ from 'lodash'
import { useEffect, useRef, useLayoutEffect, useState } from 'react'
import { useStoreState } from 'easy-peasy'
import { Empty } from 'antd'
// import { useMemo } from 'react/cjs/react.development'
import D3Bar from '../d3Bar'

const BAR_WIDTH = 34
// const DEFAULT_PADDING = 0.5
// const LineChart = ({ width, dataSource, keys }) => {
//   const data = useMemo(() => {
//     const result = {
//       id: 'te',
//       data: dataSource.map((item) => {
//         return {
//           x: item.period,
//           y: item.total,
//           bar: keys.map((key) => {
//             return {
//               key,
//               value: item[key],
//             }
//           }),
//         }
//       }),
//     }
//     return [result]
//   }, [dataSource, keys])
//   return (
//     <ResponsiveLine
//       data={data}
//       width={width}
//       useMesh={true}
//       colors={['black']}
//       margin={{ top: 50, right: 350, bottom: 100, left: 50 }}
//       axisLeft={{
//         tickSize: 5,
//         tickPadding: 5,
//         tickRotation: 0,
//         legend: 'Event',
//         legendPosition: 'middle',
//         legendOffset: -40,
//       }}
//       axisRight={null}
//       enableGridY={false}
//       axisBottom={null}
//       tooltip={(tProps) => {
//         const title = tProps.point.data.x
//         return (
//           <div className="tooltip">
//             <div className="title">{title}</div>
//             <div>
//               Event: {tProps.point.data.y?.toLocaleString(undefined, { maximumFractionDigits: 2 })}
//             </div>
//             {tProps.point.data.bar.map((item) => {
//               return (
//                 <div>
//                   {item.key}:{' '}
//                   {item.value?.toLocaleString(undefined, { maximumFractionDigits: 2 }) || 0}
//                 </div>
//               )
//             })}
//           </div>
//         )
//       }}
//     />
//   )
// }
export default function IncidentBar({ dataSource, reportAttr, period, selectDateTime }) {
  const [keys, setKey] = useState([])
  const [data, setData] = useState([])
  const { attrNumberType } = useStoreState((store) => store.monthlyDashboard)
  const containerWidth = useRef(null)
  const [width, setWidth] = useState(0)

  const [barCount, setBarCount] = useState(0)
  useLayoutEffect(() => {
    function updateSize() {
      if (barCount > containerWidth.current.offsetWidth) {
        setWidth(barCount)
      } else {
        setWidth(containerWidth.current.offsetWidth)
      }
    }
    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [barCount])
  useEffect(() => {
    const data = dataSource.data[period] || []
    const updateWidth = (count) => {
      setBarCount(count)
    }
    let barWidth = BAR_WIDTH;
    if(keys?.length > 0) {
      barWidth = barWidth * keys.length
    }
    if (!_.isEmpty(selectDateTime)) {
      const filterData = data.filter((value) => selectDateTime.includes(value.period))
      const filterDataLength = filterData.length
      updateWidth(filterDataLength * barWidth)
      setData(filterData)
    } else {
      const dataLength = data.length
      updateWidth(dataLength * barWidth)
      setData(data)
    }

    if (!_.isEmpty(reportAttr)) {
      setKey(
        dataSource.keys?.filter(
          (value) => reportAttr?.findIndex((item) => item.label === value) !== -1
        )
      )
    } else {
      setKey(dataSource.keys)
    }
  }, [dataSource, attrNumberType, reportAttr, period, selectDateTime])

  // const Line = ({ bars, xScale, yScale }) => {
  //   const lineGenerator = line()
  //     .x((bar) => bar.x + bar.width / 2)
  //     .y((bar) => yScale(bar.data.data.total))
  //   return (
  //     <Fragment>
  //       <path
  //         d={lineGenerator(bars)}
  //         fill="none"
  //         stroke="rgba(200, 30, 15, 1)"
  //         style={{ pointerEvents: 'none' }}
  //       />
  //       {bars.map((bar) => (
  //         <circle
  //           key={bar.key}
  //           cx={bar.x + bar.width / 2}
  //           cy={yScale(bar.data.data.total)}
  //           r={4}
  //           fill="white"
  //           stroke="rgba(200, 30, 15, 1)"
  //           style={{ pointerEvents: 'none' }}
  //         />
  //       ))}
  //     </Fragment>
  //   )
  // }
  return (
    <Styled className="incident-bar-component">
      <div ref={containerWidth} style={{ height: 600, overflow: 'scroll' }} id="incidentBar">
        {_.isEmpty(data) ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <div className="wrapper" id="incidentBar">
            <div className="graphContainer">
              <D3Bar
              data={data}
              width={width}
              keys={keys}
              indexBy="period"
              />
              {/* <ResponsiveBar
                data={data}
                indexBy="period"
                keys={keys}
                width={width}
                margin={{ top: 50, right: 350, bottom: 100, left: 50 }}
                padding={DEFAULT_PADDING}
                valueScale={{ type: 'linear' }}
                indexScale={{ type: 'band', round: true }}
                valueFormat={{ format: '', enabled: false }}
                colors={{ scheme: 'nivo' }}
                borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                enableGridY={true}
                // eslint-disable-next-line react/jsx-no-duplicate-props
                valueFormat=">-,"
                axisTop={null}
                axisRight={{
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: 'Amount',
                  legendPosition: 'middle',
                  legendOffset: 80,
                  format: '>-,',
                }}
                enableLabel={false}
                axisBottom={{
                  orient: 'bottom',
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 45,
                  legend: 'date',
                  legendOffset: 70,
                  legendPosition: 'center',
                }}
                axisLeft={null}
                labelSkipWidth={12}
                labelSkipHeight={12}
                labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
                legends={[
                  {
                    dataFrom: 'keys',
                    anchor: 'bottom-right',
                    direction: 'column',
                    justify: false,
                    translateX: 200,
                    translateY: 0,
                    itemsSpacing: 2,
                    itemWidth: 100,
                    itemHeight: 20,
                    itemDirection: 'left-to-right',
                    itemOpacity: 0.85,
                    symbolSize: 20,
                    effects: [
                      {
                        on: 'hover',
                        style: {
                          itemOpacity: 1,
                        },
                      },
                    ],
                  },
                ]}
                isInteractive={true}
                layers={['grid', 'axes', 'bars', 'markers', 'legends']}
              /> */}
            </div>
            {/* <div className="linechart">
              <LineChart width={width} dataSource={data} keys={keys} />
            </div> */}
          </div>
        )}
      </div>
    </Styled>
  )
}
